import type { ITableCell } from "../types";
import { getCellKind } from "./get-cell-kind";

// Shared drop-target policy for in-cell DnD (CustomDnD, dnd-kit, planners).
// A cell is a valid drop target unless it is a calc cell, a merge host
// (spans multiple cells), or a merged-away placeholder cell.
export const isValidInCellDropTarget = (cell: ITableCell): boolean => {
  if (cell.mergedInto != null) return false;
  if (cell.colSpan > 1 || cell.rowSpan > 1) return false;
  if (getCellKind(cell) === "calc") return false;
  return true;
};
